module.exports = __webpack_public_path__ + "img/patreon-light.cf2435a2.svg";